import React, { MouseEventHandler } from "react";
import useTranslation from "next-translate/useTranslation";

import { useTheme } from "@/hooks/useTheme";
import { useFela } from "react-fela";
import { Icon, StyledIconWrapper } from "@/components/Icon";
import { ILegendItem } from "../types";

interface IConverterFeaturesTab {
  isActive: boolean;
  handleClick: MouseEventHandler<HTMLButtonElement> | undefined;
  tab: ILegendItem;
}

export const ConverterFeaturesTab: React.FC<IConverterFeaturesTab> = ({
  tab,
  isActive,
  handleClick,
}) => {
  const { colors, bp } = useTheme();
  const { t } = useTranslation("page/converterFeatures");
  const { css } = useFela();

  const { icon, label } = tab;

  return (
    <button
      type="button"
      onClick={handleClick}
      className={css({
        width: "fit-content",
        display: "flex",
        alignItems: "center",
        position: "relative",
        marginBottom: 10,
        paddingBottom: 10,
        background: "none",
        border: "none",
        borderBottom: isActive
          ? `3px solid ${colors.RED}`
          : "3px solid transparent",
        fontSize: 14,
        lineHeight: "24px",
        fontWeight: 700,
        color: colors.DARK_GREY,
        whiteSpace: "normal",
        [bp.FROM_TABLET]: {
          marginBottom: 20,
          padding: "0 0 18px 0",
        },
        nested: {
          "&:not(:last-child)": {
            [bp.FROM_TABLET]: {
              marginRight: 40,
            },
          },
          "::after": {
            content: isActive ? "''" : "none",
            position: "absolute",
            bottom: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: 0,
            height: 0,
            borderStyle: "solid",
            borderWidth: "0 4px 4px 4px",
            borderColor: "transparent transparent #FF5A60 transparent",
          },
        },
      })}
    >
      <StyledIconWrapper
        wrapperStyle={{
          width: 16,
          height: 16,
          marginRight: 8,
          flexShrink: 0,
        }}
        customStyle={{ maxHeight: 16 }}
      >
        <Icon iconType={icon} />
      </StyledIconWrapper>
      {`${label} ${t("converter")}`}
    </button>
  );
};
